<div  class="mb-3">
    <span class="mb-3 ml-3 edge-text-secondary"><strong>Social Campaign</strong></span>
</div>


<div class="pl-3" class="left-border ml-5">

    <div class="my-3 row align-items-center ml-0 py-3 creative-border">
        <div class="col-lg-6 col-12 px-2 text-center d-flex align-items-center">
            <label class="my-0 font-weight-bold pl-3">Post Details</label>
        </div>
    </div>

    <div>
        <div class="row align-items-center mb-2 ml-2">
            <div class="col-lg-3 col-12">
                <label><strong>Type of Campaign
                    <span class="text-danger">*</span>
                </strong></label>
            </div>
            <div class="col-lg-9 col-12">
                <p-dropdown class="mr-0 pr-0" [style]="{width: '90%'}" [disabled]="reviewPage || campaign.campaignStatusId != 1 || 
                    ((creative.creativeTypeId == enumStandardCampaginChannel.Social_Lead_Generation || creative.creativeTypeId == enumStandardCampaginChannel.Social_Lead_Generation_Premium || creative.creativeTypeId == enumStandardCampaginChannel.Content) && (creative.primaryCreativeTypeId == enumStandardCampaginChannel.Social_Lead_Generation || creative.primaryCreativeTypeId == enumStandardCampaginChannel.Social_Lead_Generation_Premium))" autoWidth="false" (onChange)="selectedCampaignTypeChange.emit()" [(ngModel)]="this.campaign.creatives[0].creativeTypeId" [options]="campaignTypeOptions"></p-dropdown>
            </div>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-12 col-12">
            <label><strong>Post Location</strong></label>
        </div>
        <div class="col-lg-12 col-12 ml-2">
            <table class="w-50">
                <tr>
                    <th></th>
                    <th>Paid</th>
                    <th>Organic</th>
                </tr>
                <tr>
                    <td>Facebook</td>
                    <td> <p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=1 [(ngModel)]="creative.detailSocialCampaignJson.postLocation" ></p-checkbox></td>
                    <td> <p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=2 [(ngModel)]="creative.detailSocialCampaignJson.postLocation" ></p-checkbox></td>
                </tr>
            
                <tr>
                    <td>Instagram</td>
                    <td> <p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=3 [(ngModel)]="creative.detailSocialCampaignJson.postLocation"></p-checkbox></td>
                    <td> <div *ngIf="creative.detailSocialCampaignJson.postLocation?.includes('4')"><p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=4 [(ngModel)]="creative.detailSocialCampaignJson.postLocation" ></p-checkbox></div></td>

                </tr>
                <tr>
                    <td>Twitter</td>
                    <td> <p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=5 [(ngModel)]="creative.detailSocialCampaignJson.postLocation" ></p-checkbox></td>
                    <td> <div *ngIf="creative.detailSocialCampaignJson.postLocation?.includes('6')"><p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=6 [(ngModel)]="creative.detailSocialCampaignJson.postLocation" ></p-checkbox></div></td>
                </tr>
                <tr *ngIf="creative.detailSocialCampaignJson.postLocation?.includes('7') || creative.detailSocialCampaignJson.postLocation?.includes('8')">
                    <td>Snapchat</td>
                    <td> <div *ngIf="creative.detailSocialCampaignJson.postLocation?.includes('7')"><p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=7 [(ngModel)]="creative.detailSocialCampaignJson.postLocation"></p-checkbox></div></td>
                    <td> <div *ngIf="creative.detailSocialCampaignJson.postLocation?.includes('8')"><p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=8 [(ngModel)]="creative.detailSocialCampaignJson.postLocation"></p-checkbox></div></td>
                </tr>
                <tr>
                    <td>Other</td>
                    <td> <p-checkbox [disabled]="reviewPage || campaign.campaignStatusId != 1" name="postLocation" value=9 [(ngModel)]="creative.detailSocialCampaignJson.postLocation" (onChange)="onPostLocationChange()"></p-checkbox></td>
                    <td></td>
                </tr>
            </table>
            <div *ngIf="creative.detailSocialCampaignJson.postLocation?.includes('9')">
                <div class="d-flex align-items-center ">
                    <label class="mb-0 mr-2"><strong>Other Post Location
                        <span class="text-danger">*</span>&nbsp;:</strong></label>

                    <input
                        type="text"
                        class="form-control other-location-input"
                        [(ngModel)]="creative.detailSocialCampaignJson.otherPostLocation"
                        [disabled]="reviewPage || campaign.campaignStatusId != 1">
                </div>
            </div>
        </div>
    </div>


    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <label><strong>Number of Posts
                <span class="text-danger">*</span></strong></label>
        </div>
        <div class="col-lg-2 col-12">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="number" pattern="^[0-9]" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [min]=1 [step]=1  [(ngModel)]="creative.detailSocialCampaignJson.numberOfPosts" [title]="creative.detailSocialCampaignJson.numberOfPosts" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creative.detailSocialCampaignJson.numberOfPosts}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <label><strong>Target Audience</strong></label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.targetAudience" [title]="creative.detailSocialCampaignJson.targetAudience" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.targetAudience}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2">
        <div class="col-lg-3 col-12">
            <label><strong>Matching Fan365 Ads?</strong></label>
        </div>
        <div class="col-lg-9 col-12">
            <p-checkbox *ngIf="!reviewPage && campaign.campaignStatusId == 1" [binary]="true" inputId="binary" [(ngModel)]="creative.detailSocialCampaignJson.MatchingFan365Ads"></p-checkbox>
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0">{{creative.detailSocialCampaignJson.MatchingFan365Ads ? 'Yes' : 'No'}}</label>
        </div>
    </div>

    <div class="row align-items-center mb-2 ml-2" *ngIf="creative.creativeTypeId == enumStandardCampaginChannel.Paid_support">
        <div class="col-lg-3 col-12">
            <label><strong>Link to Post</strong></label>
        </div>
        <div class="col-lg-9 col-12 input-box">
            <input class="form-control" maxlength="1000" *ngIf="!reviewPage && campaign.campaignStatusId == 1" type="text" [(ngModel)]="creative.detailSocialCampaignJson.linkToPost" [title]="creative.detailSocialCampaignJson.linkToPost" style="overflow: hidden; text-overflow: ellipsis;">
            <label *ngIf="reviewPage || campaign.campaignStatusId != 1" class="mr-0 pr-0 wrap-text">{{creative.detailSocialCampaignJson.linkToPost}}</label>
        </div>
    </div>

</div>